import Vue from 'vue';
import VueRouter from 'vue-router';
import ListaDePostagens from './components/ListaDePostagens'
import DetalharPostagem from './components/DetalharPostagem'


Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: ListaDePostagens
        },
        {
            path: '/postagem/:id',
            name: 'postagemDetail',
            component: DetalharPostagem
        },
    ]
});